<template>
  <div class="price-block">
    <h5>Totaalbedrag incl BTW en BPM</h5>
    <div class="price-block__amount-wrapper">
      <h5 data-qa="total-auto-price">auto: {{ i18n.n(prices.TotalCarPrice.Incl, 'currency') }}</h5>
      <h5 data-qa="total-order-price">
        order: {{ i18n.n(prices.PurchaseOrderPrice.Incl, 'currency') }}
      </h5>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    prices: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
}
</script>

<style lang="scss" scoped>
.price-block {
  display: flex;
  justify-content: space-between;

  &__amount-wrapper {
    display: flex;
    flex-direction: column;
    text-align: right;

    > h5 {
      display: inline-block;
      white-space: nowrap;
    }
  }
}
</style>
